export default {"src":"/_next/static/media/icon-location-circle.7a8a4f29.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};